import Product from "../../../../../@types/Product";

const SeatFrames: Product[] = [
    {
        id: 1,
        name: 'None',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default SeatFrames;